export class SessionTimeoutConstants {
  public static readonly TIME_LENGTHS = {
    IDLE: 3000,
    TIMEOUT: 600
  };

  public static readonly INACTIVE_SESSION = 'Inactive Session';
}